import React from 'react'
import '../Style/Not_Found.css'
import Not_Found_Logo from '../Logos/Not-Found.png'

function Not_Found() {
    return (
        <>
            <div className='not-found-container'>
                <img src={Not_Found_Logo} alt='not-found-image-alt'/>
                <div className='not-found-text'>صفحه مورد نظر یافت نشد</div>
            </div>
        </>
    )
}

export default Not_Found